import api from '~/services/api';
import errorHandler from '~/Utils/errorHandler';

// GET ALL TAGS
export const findAllTaxItems = async () => {
  try {
    const { data } = await api.get('/taxItems/findAll');
    return data;
  } catch (error) {
    errorHandler(error);
  }
};